import "./studentDetails.css";
import { useState, useEffect, useRef } from "react";
import axios from "axios";
import { host } from "../../constants/backendpath.js";
import StudentForm from "./StudentForm.jsx";
import "../college/CollegeInfo.css";
import Button from "../../widgets/button/Button.jsx";
import AddInput from "../../widgets/addinput/input.jsx";
import { useLoader } from "../../context/LoaderContext.jsx";
import { useNavigate } from "react-router-dom";

function StudentDetails({ admin, supp, setCurrent, collegeCode }) {
  const [role, setRole] = useState(true);
  const { showLoader, hideLoader } = useLoader();
  const [selected, setSelected] = useState("");
  const [branch, setBranch] = useState([]);
  const [students, setStudents] = useState([]);
  const [appln_no, setAppln_no] = useState(false);
  const [clicked, setClicked] = useState(0);
  const [add, setAdd] = useState("");
  const formRef = useRef(null);
  const addRef = useRef(null);
  const navigate = useNavigate();

  async function handleFetch() {
    showLoader();
    // console.log('hi');
    try {
      var result;
      if (admin) {
        console.log('colege branch fetch')
        result = await axios.post(
          `${host}collegeBranchFetch`,
          { collegeCode: collegeCode },
          { withCredentials: true }
        );
      } else {
        result = await axios.get(`${host}collegeBranchFetch`, {
          withCredentials: true,
        });
      }
      if (result.status === 200) {
        // console.log(result.data);
        setBranch(result.data.branch);
        
        if (result.data.role === "admin_user") {
          setRole(false);
        }
      }
    } catch (error) {
      // console.log(error);
      navigate("/");
    } finally {
      hideLoader();
    }
  }
  useEffect(() => {
    handleFetch();
  }, []);
  useEffect(() => {
    if (clicked > 0 && formRef.current) {
      formRef.current.scrollIntoView({ behavior: "smooth" });
    }
  }, [clicked]);

  useEffect(() => {
    if (add) {
      addRef.current.scrollIntoView({ behavior: "smooth" });
    }
  }, [add]);

  async function handleSelect(branch) {
    showLoader();
    setSelected(branch);
    setAdd(false);
    setClicked(0);
    setStudents([]);
    if (branch === "") {
      hideLoader();
      return;
    }
    try {
      // console.log(supp);
      const result = await axios.post(
        `${host}studentBranch`,
        {
          branch: branch,
          ...(admin && { collegeCode: collegeCode }),
          supp: supp ? true : false,
        },
        { withCredentials: true }
      );
      if (result.status === 200) {
        setStudents(result.data);
      }
    } catch (error) {
      // console.log(error);
      if (error.response?.status === 401) navigate("/");
    } finally {
      hideLoader();
    }
  }
  const handleClear = () => {
    setClicked(0);
    setAdd(false);
    setAppln_no(false);
  };

  const deleteOne = (appln_no) => {
    setStudents((prev) =>
      prev.filter((students) => students.app_no !== appln_no)
    );
    setClicked(0);
  };
  // console.log("S="+students);

  return (
  
    <div className="student-container">
      <div className="head-studentdropdown">
        <label className="student-label">STUDENT DETAILS:</label>

        <label className="branch-label">Branch Name</label>
        <select onChange={(e) => handleSelect(e.target.value)} value={selected}>
          <option value="">--select--</option>
          {branch.map((item, index) => (
            <option key={index} value={String(item.slice(-2))}>
              {item}
            </option>
          ))}
        </select>
        {selected != "" && (
          <>
            {role && (
              <Button
                name="ADD"
                onClick={() => {
                  setAdd(true);
                  setClicked(0);
                }}
              />
            )}
          </>
        )}
        {admin && (
          <div className="admin-buttons">
            <Button
              name={"College Details"}
              style={{ width: "130px" }}
              onClick={() => setCurrent(3)}
            />
            <Button
              name={"Branch Details"}
              style={{ width: "130px" }}
              onClick={() => setCurrent(4)}
            />
          </div>
        )}
      </div>
      {selected !== "" && (
        <div className="student-table">
          <div className="student-row">
            <div className="student-header sno">S.No</div>
            <div className="student-header app_no">Application Number</div>
            <div className="student-header catogory">Catogory</div>
            <div className="student-header name">Name</div>
            <div className="student-header action">Action</div>
            <div className="student-header status">Status</div>
          </div>

          {students.map((item, index) => (
            <div key={index} className="student-row cell">
              <div className="student-cell sno">{index + 1}</div>
              <div className="student-cell app_no">{item.app_no}</div>
              <div className="student-cell catogory">{item.catogory}</div>
              <div className="student-cell name">{item.name}</div>
              <div className="student-cell action">
                <button
                  className="student-button"
                  onClick={() => {
                    // localStorage.setItem("fromView","true");
                    handleClear(); // do the same clear as Clear button
                    setTimeout(() => {
                      // then load the new student
                      setAppln_no(item.app_no);
                      setClicked(1);
                    }, 0);
                  }}
                >
                  view
                </button>
                </div>
                <div className="student-cell status">
          
                  {(Number(item.approved) === 0 || item.approved === null) && <h4 style={{ color: "orange" }}>Pending</h4>} 
                  {
                  ((Number(item.approved) === 1 && Number(item.dote_flag) === 1)  && <h4 style={{ color: "green" }}>Approved</h4>) || 
                  (Number(item.approved) === 1   && <h4>Approved</h4>)
                  }
                  {Number(item.approved) === 2 && <h4 style={{ color: "red" }} >Not Approved</h4>}
                  
                </div>
            </div>
          ))}
          {students.length === 0 && (
            <div className="Unavailable">No Students Found</div>
          )}
        </div>
      )}

      {clicked > 0 && (
        <div ref={formRef}>
          <StudentForm
            handleClear={handleClear}
            appln_no={appln_no}
            b_code={selected}
            index={deleteOne}
            clicked={clicked}
            setStudents={setStudents}
            role={role}
            {...(admin && { admin, collegeCode })}
          />
        </div>
      )}
      {add && selected !== "" && (
        <div ref={addRef}>
          <AddInput
            add={setAdd}
            clicked={setClicked}
            click={clicked}
            appln_no={setAppln_no}
            branchCode={selected}
            {...(admin && { admin })}
          />
        </div>
      )}
    </div>
  );
}

export default StudentDetails;
